import { calendarClock } from "@simplybusiness/icons";
import { Flex, Icon, Text } from "@simplybusiness/mobius";
import { useAtom } from "jotai";
import { paymentToggleAtom } from "../../../../store";
import type { PricingProps } from "../Pricing/types";
import { QuoteCardBadge, QuoteCardBadges } from "../QuoteCardBadges";
import { Premium } from "./Premium";

export const Pricing = ({
  quote,
  showInstallmentsInformation,
}: PricingProps) => {
  const {
    installmentsAvailable,
    downpaymentAmount,
    installmentsAmount,
    installmentsCount,
    installmentsTotal,
    premium,
  } = quote;
  const [paymentPeriod] = useAtom(paymentToggleAtom);
  const isMonthly = paymentPeriod === "monthly";
  const hasInstallments = installmentsAvailable && installmentsAmount;
  const showInstalments =
    isMonthly && hasInstallments && showInstallmentsInformation;
  const instalmentsText = downpaymentAmount
    ? `Then ${installmentsCount} monthly payments of`
    : `${installmentsCount} monthly payments of`;

  return (
    <div className="mobius-quote-card__pricing --is-uk">
      <Flex alignItems="flex-start" gap="xxs" justifyContent="space-between">
        <Premium
          isMonthly={isMonthly}
          hasInstallments={hasInstallments}
          installmentsAmount={installmentsAmount}
          premium={premium!}
        />
        <QuoteCardBadges className="--is-uk --is-desktop">
          <QuoteCardBadge
            icon={
              <Icon
                icon={calendarClock}
                color="var(--color-accent)"
                title="Policy duration information"
              />
            }
            data-testid="quote-card-badge-12-month-policy"
          >
            12 month policy
          </QuoteCardBadge>
        </QuoteCardBadges>
      </Flex>
      {showInstalments && (
        <div className="mobius-quote-card__instalments-grid">
          {downpaymentAmount && (
            <>
              <Text>First payment</Text>
              <Text className="mobius-quote-card__instalment_amount">
                <strong>{downpaymentAmount}</strong>
              </Text>
            </>
          )}
          <Text>{instalmentsText}</Text>
          <Text className="mobius-quote-card__instalment_amount">
            <strong>{installmentsAmount}</strong>
          </Text>
          <Text>Total over 12 months</Text>
          <Text className="mobius-quote-card__instalment_amount">
            <strong>{installmentsTotal}</strong>
          </Text>
        </div>
      )}
      <QuoteCardBadges className="--is-mobile">
        <QuoteCardBadge
          icon={
            <Icon
              icon={calendarClock}
              color="var(--color-accent)"
              title="Policy duration information"
            />
          }
          data-testid="quote-card-badge-12-month-policy"
        >
          12 month policy
        </QuoteCardBadge>
      </QuoteCardBadges>
    </div>
  );
};
